/**
 * IndicadorEnum — catálogo de indicadores usado tanto por `TemplateConfiguracao.campo` quanto
 * por `Classificacao.indicador` (mesmo catálogo nos dois models no backend, ver
 * api/models/TemplateConfiguracao.js e Classificacao.js).
 */
import { EnumBase } from 'hay-core-react';
class IndicadorEnum extends EnumBase {
  constructor() {
    super(
      [
        'main.monitoramentotemplate.testarping.testeping',
        'main.monitoramentotemplate.testequalidadestream.qualidade',
        'main.monitoramentotemplate.testeip.ipv4',
        'main.monitoramentotemplate.testeip.ipv6',
        'main.monitoramentotemplate.testeip.ippermitido',
        'main.monitoramentotemplate.testebanda.ping',
        'main.monitoramentotemplate.testebanda.jitter',
        'main.monitoramentotemplate.testebanda.download',
        'main.monitoramentotemplate.testebanda.upload',
        'main.monitoramentotemplate.testebanda.jitterup',
        'main.monitoramentotemplate.testebanda.pingup',
        'main.monitoramentotemplate.testebanda.jitterdown',
        'main.monitoramentotemplate.testebanda.pingdown',
        'main.monitoramentotemplate.testebanda.serverlocation',
        'main.monitoramentotemplate.testeua.device',
        'main.monitoramentotemplate.testeua.os',
        'main.monitoramentotemplate.testeua.navegador',
        'main.monitoramentotemplate.testeua.cpu',
      ],
      null
    );
  }
}

export default new IndicadorEnum();
